/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { HIDE_WHISPER, SHOW_WHISPER } from './whisper.types';

export const showWhisperAction = (): AnyAction => ({
    type: SHOW_WHISPER,
    payload: {
        isWhisperActive: true,
    },
});

export const hideWhisperAction = (): AnyAction => ({
    type: HIDE_WHISPER,
    payload: {
        isWhisperActive: false,
    },
});
